import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";
import Sidebar from "./Sidebar";
import HamburgerButton from "../components/HamburgerButton";
import Avatar from "./Avatar";
import NavButton from "./NavButton";
import heroSmall from "../data/images/hero-small.png";
import { TfiEmail } from "react-icons/tfi";
import {
  IoSearch,
  IoCloseSharp,
  IoChatboxEllipsesOutline,
} from "react-icons/io5";
import SearchBox from "./SearchBox";
import { Link } from "react-router-dom";
import Button from "./Button";
import BackgroundOpacity from "./BackgroundOpacity";

const Header = () => {
  const {
    user,
    conversations,
    isLoggedIn,
    activeMenu,
    setActiveMenu,
    showRoomSearch,
    handleSearchDropdown,
  } = useStateContext();

  const [unseenConversations, setUnseenConversations] = useState(false);
  const handleActiveMenu = () => setActiveMenu(!activeMenu);

  const navigate = useNavigate();
  const location = useLocation();

  const path = location.pathname;
  const isSearchPage = path === "/search" ? true : false;

  useEffect(() => {
    const usersConversations = conversations.filter(
      (x) => x.senderId === user.id || x.recipientId === user.id
    );

    const unseenConvos = usersConversations.filter(
      (x) =>
        (x.senderId === user.id && x.viewedBySender === false) ||
        (x.recipientId === user.id && x.viewedByRecipient === false)
    );

    if (unseenConvos.length > 0) setUnseenConversations(true);
  }, [conversations]);

  const closeSideBar = () => {
    // close sidebar if search is clicked
    handleActiveMenu();
    handleSearchDropdown();
  };

  return (
    <>
      {activeMenu && <BackgroundOpacity customFunc={handleActiveMenu} />}
      <div
        className="fixed top-0 w-full max-w-full box-border flex justify-between items-center h-20 bg-white 
       border-gray-300 border-b-1 px-3 overflow-hidden z-40"
      >
        <div className="pt-0">
          <NavLink
            id="logo"
            to={isLoggedIn ? "/dashboard" : "/"}
            className="text-snappily-orange text-center text-3xl"
          >
            <div className=" items-center">
              <img
                src={heroSmall}
                alt="Snappily Logo"
                className="h-20 xs:w-40 object-contain ml-1"
              />
            </div>
          </NavLink>
        </div>
        {isLoggedIn && user.defaultView === "landlord" ? (
          <>
            <div className="flex gap-x-5">
              <NavButton
                title="Messages"
                customFunc={() => {}}
                color="black"
                dotColor="#E45721"
                isDotOn={unseenConversations}
                icon={
                  <TfiEmail
                    className="text-slate-500 text-5xl mt-2"
                    onClick={() => navigate("/messages")}
                  />
                }
              />
              <NavButton
                title="Sidebar"
                customFunc={handleActiveMenu}
                color="black"
                dotColor="#BAF71F"
                isDotOn={false}
                icon={
                  activeMenu ? (
                    <div
                      className="h-12 w-12 flex justify-center items-center text-snappily-orange
                     bg-gray-200 rounded-full"
                    >
                      <IoCloseSharp
                        className="text-4xl rounded-full p-1 z-30"
                        onClick={handleActiveMenu}
                      />
                    </div>
                  ) : (
                    <Avatar user={user} />
                  )
                }
              />
            </div>
          </>
        ) : (
          <>
            {!isSearchPage && (
              <>
                {/* for large screens */}
                {/* <div
                  className="hidden sm:grid grid-cols-3 justify-items-center text-snappily-orange bg-white 
              border-snappily-orange border-2 rounded-full pl-3 pr-2 py-1 h-10 w-6/12 mt-3 cursor-pointer"
                  onClick={() => {
                    activeMenu ? closeSideBar() : handleSearchDropdown();
                  }}
                >
                  <div className="col-start-2 justify-items-center">
                    Search For Rooms
                  </div>
                  <IoSearch className="place-self-end text-2xl ml-1" />
                </div> */}
                {/* for small screens */}
                {/* <div className="flex items-center mt-5">
                  <div
                    className="flex items-center sm:hidden text-snappily-orange bg-white
                 border-snappily-orange border-2 rounded-full pl-3 pr-2 mb-1 mr-1 cursor-pointer"
                    onClick={() => {
                      activeMenu ? closeSideBar() : handleSearchDropdown();
                    }}
                  >
                    <div className="text-xs xs:text-base">Rooms</div>
                    <IoSearch className="text-2xl p-0.5 m-1" />
                  </div>
                  <HamburgerButton />
                </div> */}
              </>
            )}
            {!isSearchPage && !showRoomSearch && (
              <>
                {/* for large screens */}
                <Link
                  to="/search"
                  className="hidden sm:block h-10 w-6/12"
                  onClick={activeMenu ? () => setActiveMenu(false) : () => {}}
                >
                  <div
                    className="hidden sm:flex items-center text-snappily-orange bg-white 
              border-snappily-orange border-2 rounded-full pl-3 pr-2 py-1 mt-1.5 cursor-pointer"
                  >
                    <div className="flex justify-center w-5/6 pl-10 sm:pl-14 lg:pl-28">
                      Search for Rooms
                    </div>
                    <IoSearch className="flex justify-end w-1/6 text-2xl pl-5" />
                  </div>
                </Link>
                {/* for small screens */}
                <div className="flex items-center mt-3">
                  <Link
                    to="/search"
                    onClick={activeMenu ? () => setActiveMenu(false) : () => {}}
                  >
                    <div
                      className="flex items-center sm:hidden text-snappily-orange bg-white
                    border-snappily-orange border-2 rounded-full pl-3 pr-2 mb-1 mr-1 cursor-pointer"
                    >
                      <div className="text-xs xs:text-base">Rooms</div>
                      <IoSearch className="text-2xl p-0.5 m-1" />
                    </div>
                  </Link>
                  {/* <HamburgerButton /> */}
                </div>
              </>
            )}
            {
              <div className="flex space-between items-center mt-2">
                {!isLoggedIn && isSearchPage && (
                  <div className="mt-2 sm:pr-0">
                    <Button
                      background="bg-white"
                      text="text-snappily-orange xs:text-base"
                      opacity="bg-opacity-100"
                      title="Post a Room"
                      height="h-10"
                      width="w-28"
                      borderHover="hover:border-snappily-orange"
                      customFunc={() => {
                        navigate("/signup?action=post");
                        setActiveMenu(false);
                      }}
                    />
                  </div>
                )}

                {!isLoggedIn && (
                  <div className="mt-3">
                    <HamburgerButton />
                  </div>
                )}
              </div>
            }
            {isLoggedIn && user.defaultView === "tenant" && (
              <div className="mt-3">
                {/* <HamburgerButton /> */}
                <NavButton
                  title="Sidebar"
                  customFunc={handleActiveMenu}
                  color="black"
                  dotColor="#BAF71F"
                  isDotOn={false}
                  icon={
                    activeMenu ? (
                      <div
                        className="h-12 w-12 flex justify-center items-center text-snappily-orange
                     bg-gray-200 rounded-full"
                      >
                        <IoCloseSharp
                          className="text-4xl rounded-full p-1 z-30"
                          onClick={handleActiveMenu}
                        />
                      </div>
                    ) : (
                      <Avatar user={user} />
                    )
                  }
                />
              </div>
            )}
          </>
        )}
      </div>
      {showRoomSearch && (
        <>
          <div
            className="fixed left-0 right-0 top-20 h-30 w-screen bg-white border-b-gray-300 
          border-1 p-5 z-30"
          >
            <SearchBox
              handleSearchDropdown={() => {
                activeMenu ? closeSideBar() : handleSearchDropdown();
              }}
            />
          </div>
          <div
            className="fixed left-0 right-0 top-[10px] h-screen bg-black opacity-50 z-20"
            onClick={handleSearchDropdown}
          ></div>
        </>
      )}
      <Sidebar />
    </>
  );
};

export default Header;
